import { forwardRef } from 'react';
import { functionalHelpers } from './FunctionalHelpers.js';

function fRef(render, defaultProps) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var mergedProps = functionalHelpers(props, defaultProps);
    return render(Object.assign(Object.assign({}, mergedProps), {
      ref: ref
    }));
  });
}
function fComp(render, defaultProps) {
  var fc = function fc(props) {
    return render(Object.assign({}, props));
  };
  fc.defaultProps = defaultProps;
  return fc;
}

export { fComp, fRef };
